import { render, staticRenderFns } from "./StepRegisterOwner.vue?vue&type=template&id=010736c6"
import script from "./StepRegisterOwner.vue?vue&type=script&lang=js"
export * from "./StepRegisterOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports